import TextField from "@material-ui/core/TextField";
import React from "react";

export const TextInputLikeDropdown = ({
                              label,
                              input,
                              meta: {touched, invalid, error},
                              ...custom
                          }) => (
    <TextField
        fullWidth={true}
        label={label}
        placeholder={label}
        variant='outlined'
        color='primary'
        error={touched && invalid}
        helperText={touched && error}
        onChange={(e)=>{
            const newValue= e.target.value
            // console.log(newValue)
            input.onChange((typeof newValue === "string") ? {_id: 0, heName: newValue} : newValue)
        }}
        value={input.value.heName}
        {...custom}
    />
)
export default TextInputLikeDropdown